import "../step.js";
import "#/shared/api/api-host-global.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};

AppointmentBooking.Wizard.Views.VerifyIdStep = class VerifyIdStep extends AppointmentBooking.Wizard.Views.Step {
  constructor() {
    super(...arguments);
    this.validatePrerequisites = this.validatePrerequisites.bind(this);
    this.areRequirementsValid = this.areRequirementsValid.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.isSkippable = this.isSkippable.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
    this.getPageTitle = this.getPageTitle.bind(this);
    this.getVerifyIdQuestions = this.getVerifyIdQuestions.bind(this);
    this.idVerificationStrategy = this.idVerificationStrategy.bind(this);
  }

  validatePrerequisites() {
    return this.getVerifyIdQuestions();
  }

  areRequirementsValid() {
    if (this.model.get("verify_id_question_generation_error")) {
      return this.idVerificationStrategy() !== "block";
    } else {
      return this.areFieldsValid();
    }
  }

  isDisabled() {
    return this.idVerificationStrategy() === "off" || this.model.hasCompletedMyChartLogin();
  }

  isSkippable() {
    return this.idVerificationStrategy() === "flag" && this.model.get("verify_id_question_generation_error");
  }

  // RENDERING

  contextForRender() {
    return _.extend(super.contextForRender(...arguments), {
      id_verification_strategy: this.idVerificationStrategy(),
      verify_id_answer_indices: this.model.get("verify_id_answers").pluck("index"),
    });
  }

  // HELPER FUNCTIONS

  getPageTitle() {
    return this.I18n().verify_id.page_title;
  }

  getVerifyIdQuestions() {
    return Sparkle.Utilities.OrderedAJAX.post(
      "AppointmentBookingWizard:verify_id_questions",
      this.verifyIdQuestionsUrl,
      this.model.toValidationJSON(),
    ).then((json) => {
      this.model.set({
        verify_id_session_id: null,
        verify_id_questions: [],
        verify_id_answers: [],
        verify_id_question_generation_error: null,
      });

      if (json["success"]) {
        return this.model.set({ verify_id_session_id: json["session_id"], verify_id_questions: json["questions"] });
      } else {
        return this.model.set("verify_id_question_generation_error", true);
      }
    });
  }

  idVerificationStrategy() {
    return this.model.get("visit_type")?.id_verification_strategy;
  }
};
AppointmentBooking.Wizard.Views.VerifyIdStep.prototype.template = "step/verify_id";
AppointmentBooking.Wizard.Views.VerifyIdStep.prototype.className = "appointment-booking-wizard-verify-id-step";
AppointmentBooking.Wizard.Views.VerifyIdStep.prototype.name = "Verify ID";

AppointmentBooking.Wizard.Views.VerifyIdStep.prototype.verifyIdQuestionsUrl = window.Sparkle.apiHost
  ? window.Sparkle.apiHost + window.SparkleConfig.routes.embed.verifyIdQuestionsEhrAppointments
  : undefined;
